export interface ExtractedSource {
  _id: string;
  label: string;
  url: string;
  checked: boolean;
}

export const createMarkdownLinkPattern = (): RegExp => /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g;
export const createHtmlAnchorPattern = (): RegExp => /<a[^>]*href=["'](https?:\/\/[^"']+)["'][^>]*>(.*?)<\/a>/gi;

export function extractSourcesFromMarkdown(markdownText: string | undefined | null): ExtractedSource[] {
  if (!markdownText) return [];

  const markdownLinkPattern = createMarkdownLinkPattern();
  const htmlAnchorPattern = createHtmlAnchorPattern();
  const sourcesMap = new Map<string, ExtractedSource>();

  const addSource = (urlRaw: string, labelRaw: string): void => {
    const url = (urlRaw || "").trim();
    if (!url || sourcesMap.has(url)) return;

    const cleanedLabel = (labelRaw || "").replace(/<[^>]+>/g, "").trim();
    const isNumericRef = /^\[\d+\]$/.test(cleanedLabel) || /^\d+$/.test(cleanedLabel);
    const label = isNumericRef ? url : cleanedLabel || url;

    sourcesMap.set(url, {
      _id: `source-${sourcesMap.size + 1}`,
      label,
      url,
      checked: true
    });
  };

  let match: RegExpExecArray | null;

  while ((match = markdownLinkPattern.exec(markdownText)) !== null) {
    addSource(match[2], match[1]);
  }

  while ((match = htmlAnchorPattern.exec(markdownText)) !== null) {
    addSource(match[1], match[2]);
  }

  return Array.from(sourcesMap.values());
}
